<template>
  <div class="x-maincompany">

      <div class="x-addclass-box x-add-cexam" style="width:505px;">
        <el-form :model="addexamform" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="考试名称" prop="name" required>
            <el-input v-model="addexamform.name"></el-input>
          </el-form-item>

          <el-form-item label="考试时间" prop="starttime">
            <el-date-picker
              v-model="addexamform.starttime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="考试时间" required>
            <el-col :span="11">
              <el-form-item prop="starttime">
                <el-date-picker type="date" placeholder="选择日期" v-model="addexamform.starttime" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-date-picker type="date" placeholder="选择日期" v-model="addexamform.date2" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item> -->

          <el-form-item label="添加考试套题：" prop="" class="x-examadd-re" required>
            <el-select v-model="addexamform.region" :placeholder="placehold" @change="chanexam">
              <el-option :label="item.file_name" :value="item.file_name" v-for="item in examlist"></el-option>
            </el-select>
            <el-upload
              class="upload-demo"
              action="http://peixun.dlbbdk.com/upload/oss"
              :show-file-list="false"
              :on-success="classsucc"
              :on-remove="handleRemove"
              multiple
              :file-list="fileList">
              <el-button size="small" type="primary">继续添加(格式:.csv)</el-button>
              <div slot="tip" class="el-upload__tip"></div>
            </el-upload>
            <el-checkbox v-model="addexamform.send">开启随机分配</el-checkbox>
          </el-form-item>

          <el-form-item label="考试分配:" prop="region" required>
            <div class="x-addclass-box">
              <div class="custom-tree-container">
                <el-tree :data="treedata" node-key="id" ref="treeForm" highlight-current :default-expanded-keys="departmenttreeexpanded" @check-change="orgCheckChangeadd" :props="defaultProps" show-checkbox :check-strictly="false" :default-expand-all="true" :default-checked-keys="morenchecked"></el-tree>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="培训班" prop="" required>
            <el-select v-model="addexamform.train" placeholder="请选择">
              <el-option
                v-for="item in traindata"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="考试时长:" class="x-css-label x-studytime-css" prop="studytime">
            <el-input v-model="addexamform.studytime" class="x-input-box" clearable></el-input><span class="x-studyspan-css">秒</span>
          </el-form-item>

          <el-form-item label="考试通过分数：" required>
            <el-input-number v-model="addexamform.num" :min="60" :max="100" label="描述文字" :step="10" size="medium"></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="okadd">确认添加</el-button>
              <el-button type="primary" @click="gochange" v-if="okchange">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'maincompany',
  data () {
    return {
      addexamform:{
        name:'',
        starttime:'',
        date2:'',
        region:'',
        send:false,
        push:'',
        studytime:'',
        num:'',
        train:''
      },
      rules:{
        name: [
            { required: true, message: '请输入考试名称', trigger: 'blur' }
        ],
        starttime: [
          { type: 'date', required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择结束日期', trigger: 'change' }
        ],
        starttime:[
          {required:true,message:'请选择起止时间',trigger:'blur'}
        ],
        region: [
          // { required: true, message: '请选择考试套题', trigger: 'change' }
        ],
        studytime: [
            { required: true, message: '请输入学习时长', trigger: 'blur' }
        ],
      },
      fileList:[],
      examlist:[],
      treedata:[],
      departmenttreeexpanded:[],
      defaultProps: {
        children: '_child',
        label: 'title'
      },
      i:0,
      sids:[],
      docs:[],
      begintime:'',
      overtime:'',
      asset:'',
      placehold:'选择套题',
      morenchecked:[],
      okadd:false,
      okchange:false,
      traindata:''
    }
  },
  created() {
    this.tree()
    // 判断从编辑页
    if(this.$route.params.isedit == 1){
      this.fromeditpage(this.$route.params.classdata)
      this.okchange = true;
    }else{
      this.okadd = true;
    }
    this.trainlist()
  },
  methods:{
    //培训班列表
    trainlist:function(){
      axios.get('/admin/temp/list', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.traindata = response.data.data.list;//table数据源
            //加载列表
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //从编辑打开
    fromeditpage:function(data){
      console.log('从编辑打开：'+JSON.stringify(data));
      this.addexamform.name = data.title;

      this.addexamform.starttime=[]
      var timersstart = data.start_time;
      this.begintime=timersstart//开始时间赋值
      var timersend = data.end_time;
      this.overtime=timersend//结束时间赋值
      var datestart = new Date((parseInt(timersstart) + 8 * 3600) * 1000).toJSON().substr(0, 10).replace('T', ' ').replace(/-/g, '-');//开始日期
      var dateend = new Date((parseInt(timersend) + 8 * 3600) * 1000).toJSON().substr(0, 10).replace('T', ' ').replace(/-/g, '-');//开始日期
      console.log(this.addexamform.starttime);
      this.addexamform.starttime.push(datestart);
      this.addexamform.starttime.push(dateend);
      console.log(this.addexamform.starttime);

      this.examlist = data.assets;
      this.placehold = data.checked;
      this.asset = data.checked;

      this.addexamform.train = data.tid;

      if(data.is_rand==1){
        this.addexamform.send = true;
      }else if(data.is_rand==0){
        this.addexamform.send = false;
      }

      for(var i=0;i<data.structureids.length;i++){
        this.morenchecked.push(data.structureids[i])
      };
      this.sids = this.morenchecked;

      this.addexamform.studytime = data.test_time;
      this.addexamform.num = data.pass_score;
      console.log(this.addexamform.num);

    },
    // 时间戳转时间
    timechangetime(times){
      var date = new Date((parseInt(times) + 8 * 3600) * 1000).toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '-');
      console.log(date);
    },
    //考试题下拉框
    chanexam:function(vval){
      console.log(vval);
      this.asset = vval;
    },
    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //确认上传
    onSubmit:function(){
      console.log(this.addexamform.name);

      console.log(this.addexamform.starttime);
      let starttime = this.addexamform.starttime[0]
      let endtime = this.addexamform.starttime[1]
      //时间转时间戳
     var date = new Date(starttime);
     this.begintime = Date.parse(date) / 1000;
     console.log('任务期限开始时间戳：'+this.begintime);

      var date2 = new Date(endtime);
      this.overtime = Date.parse(date2) / 1000;
      console.log('任务期限结束时间戳：'+this.overtime);

      console.log('开始时间：'+this.begintime);
      console.log('结束时间：'+this.overtime);

      // console.log('考题列表：'+this.addexamform.region);//选择套题
      console.log('选中考题：'+this.asset);
      console.log('考题列表:'+JSON.stringify(this.examlist));
      console.log(this.addexamform.train);

      if(this.addexamform.send){
        this.addexamform.send = 1;
      }else{
        this.addexamform.send = 0;
      }
      console.log(this.addexamform.send);

      console.log('树选中id：'+this.sids);
      console.log(this.addexamform.studytime);
      console.log(this.addexamform.num);
      axios.get('/admin/examine/add', {
        params: {
          sec: localStorage.token,
          title:this.addexamform.name,
          startTime:this.begintime,
          endTime:this.overtime,
          docs:JSON.stringify(this.examlist),
          rand:this.addexamform.send,
          score:this.addexamform.num,
          testTime:this.addexamform.studytime,
          sids:this.sids,
          asset:this.asset,
          tid:this.addexamform.train
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
              this.$message({
                showClose: true,
                message: '添加考试成功',
                type: 'success'
              });

            this.$router.push({name:'examcenter'});
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

    },
    //确认修改
    gochange:function(){
      console.log(this.addexamform.name);

      console.log(this.addexamform.starttime);
      let starttime = this.addexamform.starttime[0]
      let endtime = this.addexamform.starttime[1]
      //时间转时间戳
     var date = new Date(starttime);
     this.begintime = Date.parse(date) / 1000;
     console.log('任务期限开始时间戳：'+this.begintime);

      var date2 = new Date(endtime);
      this.overtime = Date.parse(date2) / 1000;
      console.log('任务期限结束时间戳：'+this.overtime);

      console.log('开始时间：'+this.begintime);
      console.log('结束时间：'+this.overtime);

      // console.log('考题列表：'+this.addexamform.region);//选择套题
      console.log('选中考题：'+this.asset);
      console.log('考题列表:'+JSON.stringify(this.examlist));

      if(this.addexamform.send){
        this.addexamform.send = 1;
      }else{
        this.addexamform.send = 0;
      }
      console.log(this.addexamform.send);

      console.log('树选中id：'+this.sids);
      console.log(this.addexamform.studytime);
      console.log(this.addexamform.num);
      axios.get('/admin/examine/edit', {
        params: {
          sec: localStorage.token,
          title:this.addexamform.name,
          startTime:this.begintime,
          endTime:this.overtime,
          docs:JSON.stringify(this.examlist),
          rand:this.addexamform.send,
          score:this.addexamform.num,
          testTime:this.addexamform.studytime,
          sids:this.sids,
          asset:this.asset,
          id:this.$route.params.classdata.id,
          tid:this.addexamform.train
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
              this.$message({
                showClose: true,
                message: '修改考试成功',
                type: 'success'
              });

            this.$router.push({name:'examcenter'});
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //文件上传成功
    classsucc:function(res, file){
      console.log(res);
      console.log(file);
      if(res.status == 1){
        console.log(res.data[0].url);
        console.log(file.name);
        // if(this.examlist.includes(file.name)){
        //   //文件重名了
        //   this.$message({
        //     showClose: true,
        //     message: '文件重名了，请重新上传',
        //     type: 'error'
        //   });
        // }else{
          this.examlist.push({
            'file_name':file.name,
            'file_url':res.data[0].url
          })
        // }


        console.log(this.examlist);
      }else{
          this.$message({
            showClose: true,
            message:res.msg ,
            type: 'error'
          });
      }
    },
    //删除已上传文件
    handleRemove:function(){

    },
    // 树 数据源
    tree(){
      axios.get('/admin/structure/treeList', {
        params: {
          sec: localStorage.token
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.treedata = response.data.data.list
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //
    clicktree:function(){

    },
    //树
    //
    orgCheckChangeadd:function(data, checked, indeterminate){
      console.log('数据:',data,'选中状态:',checked,'子树中选中状态:',indeterminate)
      const indexs = this.sids.includes(data.id);
      console.log(indexs);//-1 没包含
      // const indexnum = data._child.length;
      // console.log(indexnum);
      var that = this;
      console.log(data.id);
      // that.addmissform.regiontwo=[]
      // console.log(data._child.length);
      // if(checked){
      //   if(data._child){//有子集
      //     for(var i=0;i<data._child.length;i++){
      //       if(that.addmissform.regiontwo.indexOf(data._child[i].id)){//如果没有
      //         console.log('没有这个id'+i);
      //         console.log(that.addmissform.regiontwo.indexOf(data._child[i].id));
      //
      //         that.addmissform.regiontwo.push(data._child[i].id)
      //       }else{
      //         console.log(that.addmissform.regiontwo);
      //         console.log(data._child[i].id);
      //         console.log('已经有这个id了');
      //       }
      //
      //     }
      //   }else{
      //     that.addmissform.regiontwo.push(data.id)
      //   }
      //
      // }else{
      //   that.addmissform.regiontwo.splice(indexs,indexnum)
      // }
      // ////////////////////////////////////////////
      if(checked && !indexs){
        console.log(that.sids);
        that.sids.push(data.id)
      }
      if(!checked && indexs){
        that.sids.splice(indexs,1)
      }

      console.log("传参用id:"+that.sids);
    },
    orgCheckChangeadd2:function(data, checked, indeterminate){
      console.log(data, '数据')
      console.log(checked, '选中状态')
      console.log(indeterminate, '子树中选中状态')
      console.log(data._child);
      // if(data._child==undefined||data._child=='undefined'){//没有子元素
        if(checked){
          console.log(data.id);//选中的id
          this.sids.push(data.id);

        }else{
          console.log(this.sids.includes(data.id));
          if(this.sids.includes(data.id)){//取消已选中
            let tind =  this.sids.indexOf(data.id);
            this.sids.splice(tind,1);
            console.log(this.sids);
          }
        }
      // }else{
      //   if(checked){
      //     console.log(data.id);//选中的id
      //     for(var i=0;i<data._child.length;i++){
      //       this.sids.push(data._child[i].id)
      //     }
      //
      //   }else{
      //     console.log(this.sids.includes(data.id));
      //
      //       // let tind =  this.sids.indexOf(data.id);
      //       // this.sids.splice(tind,1);
      //       // console.log(this.sids);
      //       for(var n=0;n<data._child.length;n++){
      //         if(this.sids.includes(data._child[n].id)){//取消已选中
      //           this.sids.splice(this.sids.indexOf(data._child[n].id),1);
      //         }
      //       }
      //       console.log(this.sids);
      //
      //   }
      //
      // }

      console.log(this.sids);
      // this.i++;
      // if(this.i%2===0){
      //     if(checked){
      //         this.$refs.treeForm.setCheckedNodes([]);
      //         this.$refs.treeForm.setCheckedNodes([data]);
      //         //交叉点击节点
      //     }else{
      //         this.$refs.treeForm.setCheckedNodes([]);
      //         //点击已经选中的节点，置空
      //     }
      // };
    }
  }
}
</script>

<style>
.x-maincompany{
  position: relative;
}
.x-maincompany .el-tabs__nav-wrap::after{
  height: 0;
}.x-maincompany .el-tabs__item.is-active{
  background-color: #BDA17A;
  color: #fff;
  border:1px solid #BDA17A;
}.x-maincompany .el-tabs__active-bar{
  height: 0;
}.x-maincompany .el-tabs__item{
  color: #BDA17A;
  border: 1px solid #BDA17A;
  background-color: #fff;
  width: 100px;
  border-radius: 4px;
  padding: 0;
  margin: 0 15px 0 0;
  text-align: center;
}.x-main-searchbox{
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}.x-btn {
    background-color: #BDA17A;
    font-size: 14px;
    color: #fff;
    text-align: center;
    height: 44px;
    line-height: 44px;
    width: 126px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    margin-right: 0;
    margin-left: 10px;
    text-decoration: none;
}.x-search-icon {
    background: url(../images/search.png)no-repeat;
    background-size: contain;
    width: 16px;
    margin-right: 8px;
    display: inline-block;
    line-height: 16px;
    height: 16px;
    vertical-align: text-bottom;
}.x-miss-addbox{
  text-align: left;
  margin-bottom: 15px;
}.x-maincompany .el-tabs__header{
  margin: 10px 0 35px 0;
}.x-maincompany .x-ac-modyfy,.x-maincompany .x-ac-remove{
  background: url(../images/change.png)no-repeat;
  background-size: contain;
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  padding-left: 25px;
  margin-right: 20px;
  display: initial;
  color: #BDA17A;
  cursor: pointer;
}.x-maincompany  .x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
}.x-ac-addbtn {
    background: url(../images/add.png)no-repeat;
    background-size: contain;
    margin-right: 10px;
    width: 10px;
    height: 10px;
    display: inline-block;
}.x-maincompany .el-table th{
  text-align: center;
}.x-go-addnews{
  text-align: left;
  margin-bottom: 20px;
}.x-maincompany .el-table .cell{
  text-align: center;
}.x-pagination{
  margin-top: 20px;
}.x-maincompany .x-btn{
  margin-left: 0;
}.x-maincompany .x-miss-addbox .el-button.el-button--primary.el-button--small{
  width: 126px;
  height: 44px;
  font-size: 14px;
}.x-noclass-desc{
  color: #ccc;
  font-size: 16px;
  padding-top: 40px;
}.x-main-btn2 {
  background: linear-gradient(180deg,rgba(255,162,162,1) 0%,rgba(255,77,77,1) 100%);
}.x-maincompany .x-main-img{
  width: 80px;
  height: 80px;
  position: absolute;
}.x-maincompany .x-main-ul li{
  border-bottom: 1px solid #DDDDDD;
  /* cursor: pointer; */
  position: relative;
  text-align: left;
  margin: 15px 0;
  padding: 15px 0 15px 0;
}.x-main-text {
  padding-left: 100px;
  color: #3F3F3F;
  font-size: 16px;
  line-height: 80px;
  height: 80px;
}.x-main-btngroup {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -22px;
}.x-ma-up{
  display: flex;
  align-items: center;
  justify-content: space-between;
}.x-add-cexam .el-form-item__content{
  text-align: left;
}.x-examadd-re .el-form-item__content{
  display: flex;
}.x-examadd-re .upload-demo{
  margin: 0 1rem;
}.x-studytime-css{
  width: 200px;
}.x-studyspan-css{
  position: absolute;
  right: -40px;
  top: 2px;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/examcenteradd.vue